import { get } from 'lodash';
import i18next from 'i18next';
import React from 'react';

import NavigationBreadCrumb from '@commons/Breadcrumb/NavigationBreadCrumb';
import theme from '@theme';
import WhiteCard from '@commons/WhiteCard';

import { Container } from './styledComponents';
import EditTranslationsCardContent from './components/EditTranslationsCardContent';

export const AdminTranslations = ({ match }) => {
  const path = get(match, 'path');

  return (
    <Container>
      <NavigationBreadCrumb featurePath={path} />
      <WhiteCard
        contentColor={theme.colors?.greys.darker}
        customStyle={{ paddingBottom: '8px' }}
        maxWidth="min(840px, 100%)"
        renderContent={<EditTranslationsCardContent />}
        title={i18next.t('ADMIN.TRANSLATIONS.TITLE')}
        width="100%"
      />
    </Container>
  );
};
